import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
import { useStyles } from './TableStyle';
export const ResizeHandle = ({ column, }) => {
    const classes = useStyles();
    return (_jsx("div", Object.assign({}, column.getResizerProps(), { style: { cursor: 'col-resize' }, className: cx({
            [classes.resizeHandle]: true,
            handleActive: column.isResizing,
        }) })));
};
//# sourceMappingURL=ResizeHandle.js.map